import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { bonusValueRows, bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-cream-beige border-y border-gold-light" data-id="element-18" data-mp="22f3f5ida9lp5">
      <div className="max-w-5xl mx-auto" data-id="element-19" data-mp="1yf30pxq6pai3">
        <div className="text-center mb-16" data-id="element-20" data-mp="1ybx9abu31wj7">
          <p className="text-navy-mid font-bold tracking-widest uppercase mb-2" data-id="element-21" data-mp="1annvnx70wf35">
            Included at no extra cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy-deep" data-id="element-22" data-mp="15qxgrd6yfpjb">
            🎁 <span className="text-gold" data-id="element-23" data-mp="1jhkdx0x2h7da">5 Strategic Bonuses</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-24" data-mp="1ep92b0syrx4w">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream-card border border-gold-light rounded-2xl p-8 relative shadow-sm hover:border-gold transition-colors" data-id="element-25" data-mp="qz59lohbdhso" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-navy-deep text-gold-light px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-26" data-mp="2jj7gaayen44f">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-gold/15 rounded-full flex items-center justify-center text-gold mb-6" data-id="element-27" data-mp="1qua9p53k2vri">
                <GiftIcon size={24} data-id="element-28" data-mp="1vstx79xssflz" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-2 pr-16 text-navy-deep" data-id="element-29" data-mp="20qvg9uv84exg">
                {bonus.title}
              </h3>
              <p className="text-navy-mid text-sm italic mb-4" data-id="element-30" data-mp="25r9d0grdk2g6">
                {bonus.tagline}
              </p>
              <div className="inline-block bg-cream-beige border border-gold-light px-3 py-1 rounded mb-4" data-id="element-31" data-mp="3c6abou7sayqg">
                <span className="text-warmgray text-sm" data-id="element-32" data-mp="3h7rbemej8f5g">
                  Real value: <span className="line-through" data-id="element-33" data-mp="1h23wpjvgnrbw">${bonus.value}</span>
                </span>
                <span className="text-gold font-bold ml-2" data-id="element-34" data-mp="1c396hwv5z0hr">→ FREE</span>
              </div>
              <div className="space-y-4 mb-6" data-id="element-35" data-mp="1q4d8ed2gtqqv">
                {bonus.paragraphs.map(paragraph => <p key={paragraph} className="text-ink text-sm leading-relaxed" data-id="element-36" data-mp="1m3jixf9dk3vv">
                    {paragraph}
                  </p>)}
              </div>
              <p className="text-forest-deep text-sm italic font-medium" data-id="element-37" data-mp="te2rajtkwr0p">
                {bonus.benefit}
              </p>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-cream-card border border-gold rounded-2xl p-6 md:p-8 max-w-2xl mx-auto shadow-sm" data-id="element-38" data-mp="1772bgz4b39el">
          <h3 className="text-2xl font-serif font-bold text-navy-deep text-center mb-4" data-id="element-39" data-mp="amth08bzhy82">
            Total value of all 5 bonuses
          </h3>
          <p className="text-xs text-warmgray text-center mb-3 md:hidden" data-id="element-40" data-mp="59uvvl9xplgs">
            ← Scroll to see full table →
          </p>
          <div className="overflow-x-auto" data-id="element-41" data-mp="3mrns8p3jnuz7">
            <table className="w-full text-sm min-w-[420px]" data-id="element-42" data-mp="3morup1vlz8ba">
              <thead data-id="element-43" data-mp="3rqha0tpv6856">
                <tr className="bg-navy-deep text-white" data-id="element-44" data-mp="3rpz6dc0vgrn8">
                  <th scope="col" className="text-left font-bold px-4 py-3 rounded-tl-lg" data-id="element-45" data-mp="j9mg43r1ny38">
                    Bonus
                  </th>
                  <th scope="col" className="text-right font-bold px-4 py-3 rounded-tr-lg" data-id="element-46" data-mp="o87dzwitq5oi">
                    Value
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-47" data-mp="e985cdy26a1i">
                {bonusValueRows.map(row => <tr key={row.label} className="border-b border-gold-light" data-id="element-48" data-mp="2u1nwbfr0ts8h">
                    <td className="px-4 py-3 text-ink" data-id="element-49" data-mp="2z0s7gbxia01g">{row.label}</td>
                    <td className="px-4 py-3 text-right text-warmgray line-through" data-id="element-50" data-mp="2yyxk6qyrhvu7">
                      {row.value}
                    </td>
                  </tr>)}
                <tr className="bg-cream-beige" data-id="element-51" data-mp="3ag579srdwexq">
                  <td className="px-4 py-3 font-bold text-navy-deep" data-id="element-52" data-mp="35htxfi13a4fi">TOTAL</td>
                  <td className="px-4 py-3 text-right font-bold text-warmgray line-through" data-id="element-53" data-mp="30jaapfeo8om3">
                    $54
                  </td>
                </tr>
                <tr data-id="element-54" data-mp="214ppsprsoo9">
                  <td className="px-4 py-4 font-bold text-navy-deep" data-id="element-55" data-mp="1zk4itpcii32">
                    Your price today
                  </td>
                  <td className="px-4 py-4 text-right font-bold text-gold text-lg" data-id="element-56" data-mp="3o8l3oaps5epo">
                    🎁 FREE
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="text-sm text-warmgray text-center mt-4" data-id="element-57" data-mp="2cu7kvk9vvpgi">
            Only included in this offer. The launch price ends soon. After this,
            the price goes up and it does not come back down.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-58" data-mp="nedn2qns3kmc" />
      </div>
    </section>;
}